import React from 'react';
import NewlaneTutorialsForm from '@components/newlane-tutorials/NewlaneTutorialsForm';
import { useGetCurrentUserQuery } from '@teachur/http-client';
const CreateNewlaneTutorials = () => {
  const { data: user } = useGetCurrentUserQuery();

  if (!user) {
    return null;
  }

  return <NewlaneTutorialsForm newlaneTutorial={{ id: -1 }} />;
};

export default CreateNewlaneTutorials;
